module.exports = __webpack_public_path__ + "img/no-permission.8e8806ab.png";